import {BOX_SCORES_WIDGET} from "../box-scores-widget-consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {BoxScoresWidgetController} from "../box-scores-widget.controller";
import {BoxScoresWidgetState} from "../models/box-scores-widget.state";
import {APP} from "../../../core/app/consts";

export class BoxScoresWidgetAllStatsClickHandler extends ActionHandler {
  controller: BoxScoresWidgetController;
  state: BoxScoresWidgetState;
  type = BOX_SCORES_WIDGET.ACTION_TYPES.allStatsToggle;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.showAllStats = !this.state.showAllStats;

    this.controller.action(BOX_SCORES_WIDGET.ANALYTICS.ACTION_TYPES.toggleClick, {
      source: APP.ANALYTICS.SOURCES.boxScores,
      gameId: this.state.dataSource.game.id,
      status: this.state.gameStatus,
      clickType: this.state.showAllStats,
      sportTypeId: this.state.dataSource.game.sport.id,
      teamId: this.state.selectedTeam.id,
    })
    return params;
  }
}
